import React, { useState } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import Popover from '../Popover';
import ClickOutside from '../../../common/utilities/ClickOutside';

const StyledPopover = styled(Popover)`
  bottom: 100%;
  width: 100%;
  max-width: none;
  top: auto;
`;

const DomainDescription = styled.p`
  white-space: pre-line;
  &:before {
    content: ' ';
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 5px 0 0;
    border-radius: 100%;
    background: ${p => p.color};
  }
`;

const ToggleButton = styled.button`
  width: 2rem;
  height: 2rem;
  margin: 0.25rem;
  padding: 0.1rem;
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;

const DomainInfo = ({ domains }) => {
  const [show, setShow] = useState(false);

  return (
    <ClickOutside onClickOutside={() => setShow(false)}>
      <Wrapper>
        <ToggleButton
          className={classnames({
            'btn rounded-circle': true,
            'btn-primary': show,
            'btn-outline-primary btn-light': !show,
          })}
          type="button"
          onClick={() => setShow(!show)}
        >
          <i className="fas fa-info" />
        </ToggleButton>
        <StyledPopover show={show} position="top">
          {domains.map(({ slug, color, description }) => (
            <DomainDescription key={slug} color={color}>
              {description}
            </DomainDescription>
          ))}
        </StyledPopover>
      </Wrapper>
    </ClickOutside>
  );
};

export default DomainInfo;
